/**
 * 首页全部语言同步引入。
 * - 纯客户端开发（serve）不会执行 serverPrefetch，原先异步加载会因 watch 无 immediate 而永远不拉取译文。
 * - 生产 SSR 注水时若首帧译文仍异步，易产生英文首帧与水合不一致。
 */

import homeLocaleEn from './home.locale.en.js';
import homeLocaleEs from './home.locale.es.js';
import homeLocaleHi from './generated/home.locale.hi.json';
import homeLocalePt from './generated/home.locale.pt.json';
import homeLocaleId from './generated/home.locale.id.json';

const withDefault = (locale) => ({
  ...homeLocaleEn,
  ...locale,
});

export const HOME_LOCALES = {
  en: homeLocaleEn,
  es: withDefault(homeLocaleEs),
  hi: withDefault(homeLocaleHi),
  pt: withDefault(homeLocalePt),
  id: withDefault(homeLocaleId),
};
